import { getTouchpointName } from '@account/account-portal/lib'
import { useConsentsState, ScenarioType, onConsentsChange, ConsentRequestPayload } from '@account/consents-shared-lib'
import { createGlassHttp } from '@crystal/glass-bridge'
import { useEffect, useMemo, useState } from 'react'

import { useViewData } from './ViewDataProvider'

export const useConsents = (scenarioType: ScenarioType) => {
  const { viewData } = useViewData()
  const initial = useConsentsState()
  const [consents, setConsents] = useState(initial)

  useEffect(() => {
    if (isEmpty(consents) && !isEmpty(initial)) {
      setConsents(initial)
    }
  }, [initial])

  const unsubscribe = useMemo(() => {
    const unsubscribe = onConsentsChange(consents => {
      if (getTouchpointName() === viewData.touchpoint) {
        setConsents(consents)
      }
    })
    return unsubscribe
  }, [])

  useEffect(() => {
    return unsubscribe
  }, [])

  return consents[scenarioType]
}

function isEmpty(obj: unknown) {
  return !obj || !Object.entries(obj as object).length
}

export function useUpdateConsents(scenarioType: ScenarioType) {
  const consentsState = useConsents(scenarioType)
  const [consentsApiError, setConsentsApiError] = useState<boolean>()
  const [isUpdatePermissionsPending, setIsUpdatePermissionsPending] = useState<boolean>(false)

  const clearApiError = () => {
    setConsentsApiError(false)
  }

  const updateConsents = async () => {
    try {
      const { legalAcceptance } = consentsState?.payload as ConsentRequestPayload
      const payload = {
        scenarioName: legalAcceptance.scenarioName,
        acceptances: legalAcceptance.acceptances,
      }
      const api = createGlassHttp()
      setIsUpdatePermissionsPending(true)
      await api.patch(`/api/permissions/update-permissions`, payload)
      setIsUpdatePermissionsPending(false)
      return
    } catch {
      setConsentsApiError(true)
    }
  }
  return { updateConsents, isUpdatePermissionsPending, consentsApiError, clearApiError }
}
